"use client";

import { Button } from "@ui/components/button";
import { ChevronLeftIcon, ChevronRightIcon } from "lucide-react";

/** "21 to 40 of 312" with previous and next. Hidden when one page is enough. */
export function Pager({
	page,
	pageSize,
	total,
	onPageChange,
}: {
	page: number;
	pageSize: number;
	total: number;
	onPageChange: (page: number) => void;
}) {
	if (total <= pageSize) {
		return null;
	}
	const pages = Math.ceil(total / pageSize);
	const first = (page - 1) * pageSize + 1;
	const last = Math.min(page * pageSize, total);

	return (
		<nav
			aria-label="Pages"
			className="flex items-center justify-between gap-3 text-muted-foreground text-sm"
		>
			<span className="tabular">
				{first.toLocaleString("en-US")} to{" "}
				{last.toLocaleString("en-US")} of{" "}
				{total.toLocaleString("en-US")}
			</span>
			<div className="flex items-center gap-1">
				<Button
					variant="outline"
					size="icon-sm"
					aria-label="Previous page"
					disabled={page <= 1}
					onClick={() => onPageChange(page - 1)}
				>
					<ChevronLeftIcon />
				</Button>
				<Button
					variant="outline"
					size="icon-sm"
					aria-label="Next page"
					disabled={page >= pages}
					onClick={() => onPageChange(page + 1)}
				>
					<ChevronRightIcon />
				</Button>
			</div>
		</nav>
	);
}
